import * as React from "react";
import styled from "styled-components";
import { Row, Col, Grid } from "components/bootstrap";
import WelcomeSearch from "components/welcome/WelcomeSearch";
import IfPermitted from "components/common/IfPermitted";
import { widgetGap } from "./Constants";
import useSecurityKpisSearch from "./hooks/useSecurityKpisSearch";
import AssetsCounter from "./tiles/AssetsCounter";
import InvestigationsCounter from "./tiles/InvestigationsCounter";
import ChartsRow from "./charts/ChartsRow";
const KpiRow = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: ${({ theme }) => widgetGap(theme)};
`;
const SearchWidgetsWrapper = styled(Grid)`
  grid-column: span 2;
  min-width: 0;

  /* The Grid centres itself with auto inline margins, which would shrink-to-fit it in its grid area. */
  width: 100%;
`;
const ChartsRowWrapper = styled.div`
  margin-top: ${({ theme }) => widgetGap(theme)};
`;
const SecurityWelcomeMetrics = () => {
  const view = useSecurityKpisSearch();
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(KpiRow, null, /* @__PURE__ */ React.createElement(SearchWidgetsWrapper, null, /* @__PURE__ */ React.createElement(WelcomeSearch, { view })), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "asset:read" }, /* @__PURE__ */ React.createElement(AssetsCounter, null)), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "investigations:read" }, /* @__PURE__ */ React.createElement(InvestigationsCounter, null))), /* @__PURE__ */ React.createElement(ChartsRowWrapper, null, /* @__PURE__ */ React.createElement(ChartsRow, null))));
};
export default SecurityWelcomeMetrics;
